import React from "react";
import { NavLink, Link } from "react-router-dom";
import logoText from "../../assets/ohhfit-text-xsmall.png";
import Badge from 'react-bootstrap/Badge';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';

function Header(props) {
    const activeStyle = { color: "orange" };
    return (
        <Navbar bg="light" expand="lg">
          <Container>
                <Navbar.Brand href="#home"><NavLink to="/" activeStyle={activeStyle} exact>
                    <img src={logoText} alt="Home" />
                </NavLink></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link>
                    <Link to="/Diets">
                    Dietas
                    </Link>
                </Nav.Link>
                        <Nav.Link>
                            <Link to="/Recipes">
                                Recetas
                            </Link>
                        </Nav.Link>
                <Nav.Link>
                    <Link to="/FoodDB">Alimentos
                    </Link>
                        </Nav.Link>
                        <Nav.Link>
                            <Link to="/Progression">
                                Progreso
                            </Link>
                        </Nav.Link>
                {props.user ? (
                    <>
                                <NavDropdown title={
                                    <>
                                        {props.user.firstName}
                                        <Badge pill variant='light'>{props.user.progressionNeeded ? "1" : ""}</Badge>
                                    </>
                                } id="basic-nav-dropdown">
                                    {props.user.progressionNeeded && (
                                        <NavDropdown.Item>
                                            <Link to="/Progression">
                                                Registra tu progreso!!
                                            </Link> </NavDropdown.Item>
                                    )}
                                    <NavDropdown.Item>
                                        <Link to="/Profile">
                                        Perfil
                                        </Link>
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item>
                                        <NavLink to="/" onClick={props.onLogOut}>Cerrar sesion</NavLink>
                                    </NavDropdown.Item>
                                </NavDropdown>
                    </>
                        ) : (
                                <Nav.Link>                                 
                                    <Link to="/Login">Iniciar sesion
                                    </Link>
                                </Nav.Link>

                        )}
                        
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
 
    );
}
export default Header;
